import { faCheck, faBox } from '@fortawesome/pro-regular-svg-icons'
import { type MantineSize, Avatar, Box, Flex, Text } from '@mantine/core'
import { forwardRef } from 'react'

import { type UNSAFE_any } from '@flecto/types'

import { Icon } from '../../../../Icon/Icon'

type MultiSelectQueryOptionProps = {
  type: string
  option: {
    badgeSize?: MantineSize
    badgeColor?: string
    checked?: boolean
    label: string
    value: string
    description?: string
    imageUrl?: string
  }
}

const CustomQueryOption = forwardRef(
  (
    { label, description, imageUrl, checked, type, ...others }: UNSAFE_any,
    ref
  ) => {
    const words = label.split(' ')
    const initials = words.length
      ? `${words[0][0]}${words[words.length - 1][0]}`
      : `${words[0][0]}${words[0][1] || ''}`

    return (
      <Flex
        gap='sm'
        justify='space-between'
        align='center'
        w='100%'
        ref={ref}
        {...others}
      >
        <Flex gap='sm' align='center'>
          {type !== 'bookings' && (
            <Avatar size='sm' radius='sm' src={imageUrl}>
              {type === 'products' ? <Icon icon={faBox} /> : initials}
            </Avatar>
          )}

          <Box>
            <Text size='sm' fw={500}>
              {label}
            </Text>
            <Text size='xs' c='dimmed'>
              {description}
            </Text>
          </Box>
        </Flex>
        {checked && (
          <Icon
            icon={faCheck}
            size='sm'
            color='green'
            data-testid='checked-icon'
            style={{ marginLeft: 'auto' }}
          />
        )}
      </Flex>
    )
  }
)

CustomQueryOption.displayName = 'CustomQueryOption'

export function MultiSelectQueryOption({
  type,
  option: { label, imageUrl, description, checked },
}: Readonly<MultiSelectQueryOptionProps>) {
  return (
    <CustomQueryOption
      type={type}
      checked={checked}
      label={label}
      description={description}
      imageUrl={imageUrl}
    />
  )
}
